// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
const burgerMenuBtn = document.getElementById('js-menu-trigger');
const burgerMenuClose = document.getElementById('burger-close');
const burgerMenu = document.getElementById('burger-menu');

(function(){


	burgerMenuBtn.addEventListener('click', (e) =>{
		e.preventDefault();
		burgerMenu.classList.add('open');
		document.body.classList.add('no-scroll', 'burger-open');
	});

	burgerMenuClose.addEventListener('click', (e) =>{
		e.preventDefault();
		burgerMenu.classList.remove('open');
		document.body.classList.remove('no-scroll', 'burger-open');
	});


	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//let scrollButtons = document.querySelectorAll('.sub-menu ul li a');

	// if(scrollButtons.length > 0){
	// 	scrollButtons.forEach((button)=>{
	// 		button.addEventListener('click', (e)=>{
	// 			e.preventDefault();
	// 			let data = button.getAttribute('href').split('#')[1];
	// 			let target = document.getElementById(data);
	// 			let headerHeight = document.querySelector('header').offsetHeight + 55;

	// 			window.scrollTo({
	// 				top: target.offsetTop - headerHeight,
	// 				behavior: 'smooth'
	// 			});
	// 		});
	// 	});
	// }

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

const focusableSelector = `
  a[href],
  button,
  input,
  textarea,
  select,
  [tabindex]:not([tabindex="-1"])
`;

function disableFocusOutside(container, key) {
	const focusables = document.querySelectorAll(focusableSelector);
  
	focusables.forEach(el => {
	  if (container.contains(el)) return;
  
	  const attr = `data-prev-tabindex-${key}`;
  
	  if (!el.hasAttribute(attr)) {
		const prev = el.getAttribute('tabindex');
		el.setAttribute(attr, prev === null ? 'none' : prev);
	  }
  
	  el.setAttribute('tabindex', '-1');
	});
}
  
  
function restoreFocus(key) {
	const stored = document.querySelectorAll(`[data-prev-tabindex-${key}]`);
  
	stored.forEach(el => {
	  const prev = el.getAttribute(`data-prev-tabindex-${key}`);
  
	  if (prev === 'none') {
		el.removeAttribute('tabindex');
	  } else {
		el.setAttribute('tabindex', prev);
	  }
  
	  el.removeAttribute(`data-prev-tabindex-${key}`);
	});
}

function updateMenuTabIndex() {
	const isMenuVisible = burgerMenu && burgerMenu.classList.contains('open');
	const elements = document.querySelectorAll('#burger-menu a');
	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}

function splitFadeWords() {
	const BASE_DELAY = 600;
	const DELAY_PER_WORD = 150;
  
	document.querySelectorAll('.js-fade-words').forEach(el => {
		// Split innerHTML on whitespace OR on <br> tags, keeping <br> as a token
		const tokens = el.innerHTML.trim().split(/(<br\s*\/?>)|\s+/);
	
		let wordIndex = 0;
		el.innerHTML = tokens
		  .filter(token => token)
		  .map(token => {
			// Pass <br> tags through as-is
			if (/^<br\s*\/?>$/i.test(token)) {
			  return `<br>`;
			}
			const delay = BASE_DELAY + (wordIndex++ * DELAY_PER_WORD);
			return `
			  <div class="word" aria-hidden="true" style="transition-delay: ${delay}ms">
				<span style="transition-delay: ${delay}ms">${token}</span>
			  </div>
			`;
		  }).join('');
	  });
}
  
const observer = new IntersectionObserver((entries) => {
	entries.forEach(entry => {
	  if (entry.isIntersecting) {
		entry.target.classList.add('is-visible');
		observer.unobserve(entry.target);
	  }
	});
}, { threshold: 0.2 });
  
document.addEventListener('DOMContentLoaded', () => {

	//title animation 
	splitFadeWords();
  
	requestAnimationFrame(() => {
		document.querySelectorAll('.js-fade-words').forEach(el => {
			observer.observe(el);
		});
	});

	//keyboard focus accessibility 
	if(screen.width > 600) {
		updateMenuTabIndex();
		burgerMenu.addEventListener('transitionend', updateMenuTabIndex);

		const burgerObserver = new MutationObserver(() => {
			if (document.body.classList.contains("burger-open")) {
				disableFocusOutside(burgerMenu, 'burger');
			} else {
				restoreFocus('burger');
			}
		});
		
		burgerObserver.observe(document.body, {
			attributes: true,
			attributeFilter: ["class"]
		});
	}

});
// preloader
const loader = document.getElementById("loader-wrapper");

if (loader) {
  loader.style.display = "block";

  let hideTimer = null;
  let isHiding = false;

  const hideLoader = () => {
    if (isHiding) return;
    isHiding = true;

    if (hideTimer) clearTimeout(hideTimer);

    const videos = loader.querySelectorAll("video");
    videos.forEach((video) => video.pause());

    loader.style.pointerEvents = "none";
    loader.style.transition = "opacity 0.4s ease";
    loader.style.opacity = "0";

    setTimeout(() => {
      loader.style.display = "none";
      loader.classList.add("hiden");
    }, 400);
  };

  hideTimer = setTimeout(hideLoader, 26000);
  loader.addEventListener("click", hideLoader);
}